import dataLayer from '@/v2/utils/dataLayer';

export const viewAllOptionsClickedDataLayerEvent = ({
  pageName,
}: {
  pageName: string;
}) =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: 'View all options',
    label: `${pageName}`,
  });

// Popup appeared event requested alongside `View all Options` CTA
export const popupAppearedDataLayerEvent = ({
  pageName,
}: {
  pageName: string;
}) =>
  dataLayer.userInteractionsEvent({
    category: 'Popup appeared',
    action: `Upgrade your package`,
    label: `${pageName} popup`,
  });

export const propertyCTAClickedDataLayerEvent = ({
  pageName,
  isPresearch,
}: {
  pageName: string;
  isPresearch: boolean;
}) =>
  dataLayer.userInteractionsEvent({
    category: 'CTA Click',
    action: isPresearch ? 'Check availability' : 'Select package',
    label: `${pageName}`,
  });
